import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/i18n";
import HomePage from "@/pages/HomePage";
import Admin from "@/pages/Admin";
import { PrivacyPolicy, MedicalDisclaimerPage, TermsPage, NotFound } from "@/pages/LegalPages";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/medical-disclaimer" element={<MedicalDisclaimerPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
